"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _activeBinding = require("@/api/activeBinding");
var _ActivitySelectionPopup = _interopRequireDefault(require("./ActivitySelectionPopup.vue"));
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ActivitySelectionPopup: _ActivitySelectionPopup.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      tableData: [],
      picImg: null,
      // 图片
      rules: {},
      listIndex: 0,
      // 列表第几项
      modelId: null
    };
  },
  methods: {
    open: function open(data) {
      this.modelId = data.id;
      this.dialogVisible = true;
      this.marqueeListApi();
    },
    onClose: function onClose() {
      this.queryData = {};
      this.dialogVisible = false;
    },
    handleAvatarSuccess: function handleAvatarSuccess() {},
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.picImg = pictureUrl;
              this.marqueeUploadPicApi();
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    // 开关
    onChangeSwitch: function onChangeSwitch(data, value) {
      // 存在id且不在剪辑状态
      if (data.id && data.inputState) {
        this.marqueeUpdateStatusApi(data.id, value);
      }
    },
    onSave: function onSave(data, index) {
      var _this = this;
      console.log(data, index);
      if (!this.picImg) {
        this.$message({
          type: 'warning',
          message: '请先上传图片!'
        });
        return;
      }
      if (data.id) {
        this.$confirm('是否确认编辑此活动?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this.marqueeUpdateApi(data);
        });
      } else {
        this.$confirm('是否确认添加此活动?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this.marqueeSaveApi(data);
        });
      }
    },
    onDelete: function onDelete(data, index) {
      var _this2 = this;
      if (data.id) {
        this.$confirm('是否确认删除此活动?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this2.marqueeDeleteApi(Number(data.id));
        });
      } else {
        this.tableData.splice(index, 1);
      }
    },
    onAdd: function onAdd() {
      this.tableData.push({
        pic: '',
        content: '',
        jumpType: '1',
        jumpContent: '',
        // url
        activityId: null,
        activityName: '',
        activityType: null,
        enable: false,
        inputState: false
      });
    },
    onRadioChange: function onRadioChange(index) {
      console.log('index', index);
      this.listIndex = index;
      this.$refs.activitySelectionPopup.open();
    },
    // 自定义货多功能回传
    onSelectEvents: function onSelectEvents(data) {
      console.log('自定义货多功能回传', data);
      this.tableData[this.listIndex].activityType = data.Display_type;
      this.tableData[this.listIndex].openUrl = data.openUrl;
      if (data.Display_type === 4) {
        // 通用H5活动 回填
        this.tableData[this.listIndex].activityName = data.name;
        this.tableData[this.listIndex].activityId = data.pageId;
      } else if (data.Display_type === 5) {
        this.tableData[this.listIndex].activityName = data.title;
        this.tableData[this.listIndex].activityId = data.id;
      } else if (data.Display_type === 6) {
        this.tableData[this.listIndex].activityName = data.activityName;
        this.tableData[this.listIndex].activityId = data.id;
      } else if (data.Display_type === 8) {
        this.tableData[this.listIndex].activityName = data.activityName;
        this.tableData[this.listIndex].activityId = data.id;
      } else {
        this.tableData[this.listIndex].activityName = data.name;
        this.tableData[this.listIndex].activityId = data.id;
      }
    },
    marqueeListApi: function () {
      var _marqueeListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, ProcessingList, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                modelId: this.modelId
              };
              _context2.n = 1;
              return (0, _activeBinding.marqueeListApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                ProcessingList = [];
                res.data.marqueeList.forEach(function (item) {
                  item.inputState = true;
                  ProcessingList.push(item);
                });
                this.tableData = ProcessingList;
                this.picImg = res.data.pic;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function marqueeListApi() {
        return _marqueeListApi2.apply(this, arguments);
      }
      return marqueeListApi;
    }(),
    marqueeSaveApi: function () {
      var _marqueeSaveApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(data) {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                content: data.content,
                jumpType: data.jumpType,
                jumpContent: data.jumpContent,
                activityId: data.activityId,
                activityName: data.activityName,
                activityType: data.activityType,
                enable: data.enable,
                openUrl: data.openUrl
              };
              _context3.n = 1;
              return (0, _activeBinding.marqueeSaveApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '保存成功'
                });
                this.marqueeListApi();
                this.$parent.getHorseList(this.modelId);
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function marqueeSaveApi(_x2) {
        return _marqueeSaveApi2.apply(this, arguments);
      }
      return marqueeSaveApi;
    }(),
    marqueeUpdateApi: function () {
      var _marqueeUpdateApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(data) {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                content: data.content,
                jumpType: data.jumpType,
                jumpContent: data.jumpContent,
                activityId: data.activityId,
                activityName: data.activityName,
                activityType: data.activityType,
                enable: data.enable,
                id: data.id,
                openUrl: data.openUrl
              };
              _context4.n = 1;
              return (0, _activeBinding.marqueeUpdateApi)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
                this.marqueeListApi();
                this.$parent.getHorseList(this.modelId);
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function marqueeUpdateApi(_x3) {
        return _marqueeUpdateApi2.apply(this, arguments);
      }
      return marqueeUpdateApi;
    }(),
    marqueeDeleteApi: function () {
      var _marqueeDeleteApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(id) {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = {
                id: id
              };
              _context5.n = 1;
              return (0, _activeBinding.marqueeDeleteApi)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
                this.marqueeListApi();
                this.$parent.getHorseList(this.modelId);
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t5 = _context5.v;
              console.log(_t5);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function marqueeDeleteApi(_x4) {
        return _marqueeDeleteApi2.apply(this, arguments);
      }
      return marqueeDeleteApi;
    }(),
    marqueeUpdateStatusApi: function () {
      var _marqueeUpdateStatusApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(id, value) {
        var params, res, _t6;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = {
                id: id,
                enable: value
              };
              _context6.n = 1;
              return (0, _activeBinding.marqueeUpdateStatusApi)(params);
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.marqueeListApi();
                this.$parent.getHorseList(this.modelId);
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t6 = _context6.v;
              console.log(_t6);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function marqueeUpdateStatusApi(_x5, _x6) {
        return _marqueeUpdateStatusApi2.apply(this, arguments);
      }
      return marqueeUpdateStatusApi;
    }(),
    marqueeUploadPicApi: function () {
      var _marqueeUploadPicApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7() {
        var params, res, _t7;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              params = {
                modelId: this.modelId,
                pic: this.picImg
              };
              _context7.n = 1;
              return (0, _activeBinding.marqueeUploadPicApi)(params);
            case 1:
              res = _context7.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '添加成功'
                });
                this.marqueeListApi();
                this.$parent.getHorseList(this.modelId);
              }
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t7 = _context7.v;
              console.log(_t7);
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function marqueeUploadPicApi() {
        return _marqueeUploadPicApi2.apply(this, arguments);
      }
      return marqueeUploadPicApi;
    }()
  }
};